/* eslint-disable react-hooks/exhaustive-deps */
import { Fragment, useMemo, useState } from 'react';
import { TabItemProps } from '@consumidor-positivo/aurora';
import isMobile from '@libs/utils/helpers/isMobile';
import { useDeviceSize } from '@libs/utils/hooks/useDeviceSize';

import { OfferCard } from '../../../../components/OfferCard';
import { SHOffer } from '../../../../services/sortingHat';

import { OfferListTabProps } from '.';

// Colunas do grid `.offer-list-tab__container` por breakpoint (ver styles.scss).
const getGridColumns = (width: number | null) => {
  if (!width) return 1;
  if (width >= 1200) return 4;
  if (width >= 900) return 3;
  if (width >= 600) return 2;
  return 1;
};

export function useOfferListTab(props: OfferListTabProps) {
  const { offerForBenefits, OffersMiddleAd, SofiaInlineBanner, location, user, initalBenefitTab } = props;
  const { windowWidth } = useDeviceSize();

  const [benefitsTabs, setBenefitsTabs] = useState<TabItemProps[]>([]);
  const adsCard = (index: number) => {
    if (!isMobile()) return;
    if (index !== 3) return;
    if (!Boolean(OffersMiddleAd)) return;
    return <OffersMiddleAd />;
  };

  // Banner da Sofia (Teste 1 — Variante B): após a 1ª fileira de ofertas.
  // Mobile (1 col) = após a 1ª oferta; desktop = após a última oferta da 1ª fileira.
  // `total` = nº de ofertas da lista: se a categoria tem menos ofertas que uma fileira
  // completa, o banner vai após a ÚLTIMA oferta (senão sumia em categorias pequenas).
  const sofiaBanner = (index: number, total: number) => {
    if (!Boolean(SofiaInlineBanner)) return;
    if (index !== Math.min(getGridColumns(windowWidth), total) - 1) return;
    return (
      <div className="offer-list-tab__sofia-banner">
        <SofiaInlineBanner />
      </div>
    );
  };

  useMemo(() => {
    const tabsWithOffers = offerForBenefits?.filter((filter) => filter?.list?.length > 0);
    const updatedTabs: TabItemProps[] = tabsWithOffers?.map(({ list, ...tabs }) => {
      return {
        ...tabs,
        children: (
          <div className="offer-list-tab__container">
            {list?.map((item: SHOffer, index: number) => {
              return (
                <Fragment key={item.generalInfo.id}>
                  <OfferCard offer={item} index={index} location={location} user={user} />
                  {sofiaBanner(index, list.length)}
                  {adsCard(index)}
                </Fragment>
              );
            })}
          </div>
        ),
      };
    });

    setBenefitsTabs(updatedTabs);
    // Depende do nº de colunas (valor discreto), não do pixel bruto: só a mudança de
    // coluna reposiciona o banner da Sofia. `useDeviceSize` atualiza `windowWidth` a cada
    // evento `resize` sem debounce — usar o pixel recomputaria a lista quase todo frame.
  }, [offerForBenefits, initalBenefitTab, getGridColumns(windowWidth)]);

  return {
    benefitsTabs,
    adsCard,
    sofiaBanner,
  };
}
